import React, { useState, useEffect } from 'react';
import Hamster from '../img/DALL_E_2025_01_17_17_21_18_A_playful_and_vibrant_illustration_of-removebg-preview (2).png';

const HamsterAnimation = () => {
	const [position, setPosition] = useState({
		top: '50%',
		left: '50%',
		flipped: false,
	})

	useEffect(() => {
		const generatePositions = () => {
			const percentages = ['10%', '50%', '90%']
			return percentages.flatMap(top => [
				{ top, left: '0%', flipped: true },
				{ top, left: '90%', flipped: false },
			])
		}

		const updatePosition = () => {
			const positions = generatePositions()
			const randomIndex = Math.floor(Math.random() * positions.length)
			setPosition(positions[randomIndex])
		}

		const interval = setInterval(() => {
			updatePosition()
		}, 5000)

		return () => clearInterval(interval)
	}, [])

	return (
		<img
			className={`hamster ${position.flipped ? 'flipped' : ''}`}
			src={Hamster}
			style={{ top: position.top, left: position.left, position: 'absolute' }}
			alt='Hamster'
		/>
	)
}

export default HamsterAnimation;
